<h1 mat-dialog-title>Reorder Contents</h1>
<div mat-dialog-content>
    <div
        cdkDropList
        cdkDropListOrientation="horizontal"
        class="example-list"
        (cdkDropListDropped)="drop($event)"
    >
        @for (child of data.children; track child) {
            <div cdkDragLockAxis="x" cdkDrag>
                <div class="root loaded">
                    <div
                        class="asset-type"
                        [style.border-color]="AssetColorMap.get(child.asset_type)"
                    >
                        @if (child.asset_type !== AssetType.Image) {
                            <mat-icon>{{ IconMap.get(child.asset_type) }}</mat-icon>
                        }
                    </div>
                    <img [src]="child.thumbnail" />
                    <div class="thumbnail-details">
                        <p class="truncate">{{ child.name }}</p>
                        <small class="author primary">{{ child.author.name | titlecase }}</small>
                        <button mat-icon-button color="warn" (click)="remove(child)" class="remove">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
<div mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>Close</button>
</div>
